// extracted by mini-css-extract-plugin
module.exports = {"heading":"GridColumn_heading__G6D33","content":"GridColumn_content__0_FR7"};